export enum ActionTypeEnum {
    Scenario = 'Scenario',
    Player = 'Player',
    Widget = 'Widget',
    Product = 'Product',
    ProductJump = 'ProductJump',
}

export enum ActionPlayerTypeNameEnums {
    copy = 'copy',
    showToast = 'showToast',
    closeBottomsheet = 'closeBottomsheet',
    closeFramework = 'closeFramework',
}

/**
 * Prefix for the generic "persist a value to local storage" player action.
 * The action name is `save_local_data:<key>`, where `<key>` (e.g. `theme`, `lang`)
 * is the IndexedDB key the value is written under and that other widgets read back.
 */
export const SAVE_LOCAL_DATA_PREFIX = 'save_local_data:';

export enum LocalDataKeys {
    theme = 'theme',
    lang = 'lang',
}

export enum EnterprisePlayerActionNameEnum {
    redirect = 'redirect',
}

export enum ActionActionTypeEnum {
    onClick = 'onClick',
    onDoubleClick = 'onDoubleClick',
    onHover = 'onHover',
    onRedirect = 'onRedirect',
    onFilled = 'onFilled',
    onFill = 'onFill',
    onTimer = 'onTimer',
    onRefresh = 'onRefresh',
    onEndOfList = 'onEndOfList',
    onItemSelected = 'onItemSelected',
    onCalculate = 'onCalculate',
    onUpdateList = 'onUpdateList',
    closeBottomsheet = 'closeBottomsheet',
}

export enum ActionSystemActionType {
    navigateBack = 'navigateBack',
    navigateForward = 'navigateForward',
    rotate = 'rotate',
    shake = 'shake',
    take = 'take',
}

export enum FunctionEventTypeEnum {
    HIDE = 'hide',
    SHOW = 'show',
    ENABLED = 'enabled',
    DISABLED = 'disabled',
    HIDDEN = 'hidden',
    PATH = 'path',
    IS_VALID = 'isValid',
    VALUE = 'value',
}

export enum JsonPathEnum {
    IS_VALID = '$.isValid',
    VALUE = '$.data.value',
    IS_HIDE = '$.options.isHide',
    IS_DISABLED = '$.options.isDisabled',
    ENABLED = '$.options.enabled',
}

export enum TextInputEnum {
    ENTERPASSCODE = 'EnterPasscode',
}

export enum LayoutEnum {
    BOTTOM_SHEET = 'BottomSheet',
    MODAL_WINDOW = 'ModalWindow',
}
